import { useSelector } from "react-redux";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import React, { Fragment, useEffect, useState } from "react";
import {
  Business,
  AccountCircle,
  Sell,
  CorporateFare,
} from "@mui/icons-material";

import Form from "./profile details components/Form";
import { colors } from "../css components/Style";
import BrandDetails from "../brand components/BrandDetails";
import CompanyDetails from "../company components/CompanyDetails";
import AgencyDetails from "../agency components/Agency";

const TabButton = styled(Button)`
  text-transform: none;
  padding: 10px 25px;
  font-weight: 500;
  letter-spacing: 0.18px;
  font-size: 15px;
`;

export default function Profile() {
  const { userData, role } = useSelector((state) => state.memberDetails);

  const [formData, setFormData] = useState(userData);

  const [selectedTab, setSelectedTab] = useState("User Profile");

  const [tabItems, setTabItems] = useState([
    {
      label: "User Profile",
      icon: <AccountCircle style={{ height: "32px", width: "32px" }} />,
    },
  ]);

  useEffect(() => {
    if (role === "AGENCY") {
      setTabItems((prev) => [
        ...prev,
        // {
        //   label: "Company",
        //   icon: <Business style={{ height: "32px", width: "32px" }} />,
        // },
        {
          label: "Agency",
          icon: <CorporateFare style={{ height: "32px", width: "32px" }} />,
        },
      ]);
    }

    if (role === "NORMAL_USER") {
      setTabItems((prev) => [
        ...prev,
        {
          label: "Brand",
          icon: <Sell style={{ height: "32px", width: "32px" }} />,
        },
      ]);
    }
  }, [role]);
  return (
    <Fragment>
      <Stack direction="row" spacing={2} style={{ marginBottom: "20px" }}>
        {tabItems.map((tab) => {
          const isSelected = selectedTab === tab.label;

          return (
            <TabButton
              key={tab.label}
              onClick={() => setSelectedTab(tab.label)}
              startIcon={tab.icon}
              sx={{
                backgroundColor: isSelected
                  ? colors.publicisBlue
                  : "transparent",
                color: isSelected ? "#fff" : colors.publicisBlue,
                "&:hover": {
                  backgroundColor: isSelected
                    ? colors.publicisBlue
                    : colors.hoverBlue,
                  color: isSelected ? "#fff" : colors.publicisBlue,
                },
              }}
            >
              {tab.label}
            </TabButton>
          );
        })}
      </Stack>

      {selectedTab === "User Profile" && (
        <Form formData={formData} setFormData={setFormData} />
      )}

      {selectedTab === "Brand" && <BrandDetails />}

      {selectedTab === "Agency" && <AgencyDetails />}

      {/* {selectedTab === "Company" && <CompanyDetails withCompany={true} />} */}
    </Fragment>
  );
}
